import React__default from 'react';
import { I as Icon } from './index-11bc5ac3.js';

var setDomAttributes = function setDomAttributes(ref, domAttributes) {
  if (ref.current && domAttributes.length) {
    domAttributes.forEach(function (attr) {
      return ref.current.setAttribute(attr.attribute, attr.value);
    });
  }
};
var renderStars = function renderStars(quantity) {
  var star = [];
  for (var index = 0; index < quantity; index++) {
    star.push(/*#__PURE__*/React__default.createElement(Icon, {
      name: "bf-icon-star-solid",
      key: "STAR_".concat(index)
    }));
  }
  return star;
};
var transformCamelToKebab = function transformCamelToKebab(key) {
  return key.replace(/([A-Z])/g, '-$1').toLowerCase();
};
var getClassName = function getClassName(classKeys) {
  for (var _len = arguments.length, moreClasses = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    moreClasses[_key - 1] = arguments[_key];
  }
  var classNames = moreClasses.length > 0 ? [].concat(moreClasses) : [];
  Object.keys(classKeys).filter(function (k) {
    return classKeys[k];
  }).map(function (key) {
    return classNames.push(transformCamelToKebab(key));
  });
  return classNames.join(' ').trim();
};

export { getClassName as g, renderStars as r, setDomAttributes as s };
//# sourceMappingURL=utilsHelpers-e4b21f4b.js.map
